<template>
  <v-dialog v-model="competitionFinishedDialog" width="35rem">
    <v-card width="35rem">
      <v-row class="ma-0 pt-4 pb-4">
        <v-col cols="2" class="ma-0 mt-0 pa-0">
          <v-avatar color="#EEFFEF" size="3.6rem" class="ml-4">
            <v-icon color="#11D800">mdi-check</v-icon>
          </v-avatar>
        </v-col>
        <v-col cols="10" class="mt-1 pa-0">
          <v-col class="pa-0">
            <span style="color: #5edc11; font-weight: 500; font-size: 1.3rem"
              >Submit Successfully</span
            >
          </v-col>
          <v-col class="pa-0 mt-2">
            Congratulations on finishing the test. Your answers have been submit
            successfully. Thanks!
          </v-col>
          <v-col cols="10" class="pa-0 mt-4">
            <v-btn width="100%" dark color="#5EDC11" @click="closeDialog()"
              >OK</v-btn
            >
          </v-col>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import confetti from "canvas-confetti";

export default {
  name: "CompetitionFinishedDailog",
  data() {
    return {
      competitionFinishedDialog: false,
    };
  },
  methods: {
    openDialog() {
      this.competitionFinishedDialog = true;
      this.triggerConfetti();
    },
    closeDialog() {
      this.competitionFinishedDialog = false;
    },
    triggerConfetti() {
      confetti({
        particleCount: 2500,
        spread: 500,
        origin: { y: 0.35 },
      });
    },
  },
};
</script>